module.exports = __webpack_public_path__ + "c8c0a18b05506e401f067926ba3a50cb.png";